<div class="container-fluid animated fadeIn">
	<div class="page-header-wrapper">
		<div class="page-header">
			<div class="page-header-left">
				<h2>
					{{ 'company-details.edit.pageTitle' | translate }}
				</h2>
				<eif-custom-breadcrumbs [breadcrumbItems]="breadcrumbItems"></eif-custom-breadcrumbs>
			</div>
		</div>
	</div>

	<form
		#editCompanyForm="ngForm"
		autocomplete="off"
		novalidate
		(ngSubmit)="updateCompanyData()">
		<div class="simple-card top-line p-5 d-grid gap-5">
			<div class="is-content-section">
				<div class="is-content-section-fields">
					<div class="is-content-section-field">
						<p class="is-label">{{ 'company-details.countryCode' | translate }}</p>
						<p class="is-value">{{ company?.CountryCode }} - {{ company?.CountryCode | translate: 'CountryCode' }}</p>
					</div>
					<div class="is-content-section-field">
						<p class="is-label">{{ 'company-details.vatNumber' | translate }}</p>
						<p class="is-value">{{ company?.VatNumber }}</p>
					</div>
				</div>
			</div>
		</div>

		<div class="simple-card p-5 d-grid gap-5 mt-5">
			<div class="is-content-section">
				<div class="is-content-section-fields">
					<eif-custom-input
						#nameInput
						[class]="'is-one-column'"
						[label]="'company-details.name' | translate"
						[placeholder]="'company-details.name' | translate"
						[validationRules]="getValidationRules('name')"
						[value]="company?.Name"
						(valueChange)="onValueChange('name', $event)"
						(validationChange)="onValidationChange('name', $event)">
					</eif-custom-input>
				</div>
			</div>

			<div class="is-content-section">
				<div class="is-content-section-fields">
					<eif-custom-input
						#addressLine1Input
						[label]="'company-details.addressLine1' | translate"
						[placeholder]="'company-details.addressLine1' | translate"
						[validationRules]="getValidationRules('addressLine1')"
						[value]="company?.AddressLine1"
						(valueChange)="onValueChange('addressLine1', $event)"
						(validationChange)="onValidationChange('addressLine1', $event)">
					</eif-custom-input>
					<eif-custom-input
						#addressLine2Input
						[label]="'company-details.addressLine2' | translate"
						[placeholder]="'company-details.addressLine2' | translate"
						[value]="company?.AddressLine2"
						(valueChange)="onValueChange('addressLine2', $event)"
						(validationChange)="onValidationChange('addressLine2', $event)">
					</eif-custom-input>
					<eif-custom-input
						#addressLine3Input
						[label]="'company-details.addressLine3' | translate"
						[placeholder]="'company-details.addressLine3' | translate"
						[value]="company?.AddressLine3"
						(valueChange)="onValueChange('addressLine3', $event)"
						(validationChange)="onValidationChange('addressLine3', $event)">
					</eif-custom-input>
					<eif-custom-input
						#zipCodeInput
						[label]="'company-details.zipCode' | translate"
						[placeholder]="'company-details.zipCode' | translate"
						[validationRules]="getValidationRules('zipCode')"
						[value]="company?.ZipCode"
						(valueChange)="onValueChange('zipCode', $event)"
						(validationChange)="onValidationChange('zipCode', $event)">
					</eif-custom-input>
					<eif-custom-input
						#cityInput
						[label]="'company-details.city' | translate"
						[placeholder]="'company-details.city' | translate"
						[validationRules]="getValidationRules('city')"
						[value]="company?.City"
						(valueChange)="onValueChange('city', $event)"
						(validationChange)="onValidationChange('city', $event)">
					</eif-custom-input>
					<eif-custom-input
						#activityCodeInput
						[label]="'company-details.activityCode' | translate"
						[placeholder]="'company-details.activityCode' | translate"
						[maxLength]="10"
						[validationRules]="getValidationRules('activityCode')"
						[value]="company?.ActivityCode"
						(valueChange)="onValueChange('activityCode', $event)"
						(validationChange)="onValidationChange('activityCode', $event)"
						(keydown)="onActivityCodeKeyPress($event)">
					</eif-custom-input>
				</div>
			</div>

			<div class="is-content-section">
				<div class="is-content-section-fields">
					<eif-custom-select
						#timeZoneSelect
						[label]="'company-details.timeZone' | translate"
						[placeholder]="'company-details.timeZone' | translate"
						[options]="timeZoneOptions"
						[fullWidth]="true"
						[validationRules]="getValidationRules('timeZone')"
						[value]="company?.TimeZone"
						(valueChange)="onValueChange('timeZone', $event)"
						(validationChange)="onValidationChange('timeZone', $event)">
					</eif-custom-select>
					<eif-custom-select
						#languageCodeSelect
						[label]="'company-details.languageCode' | translate"
						[placeholder]="'company-details.languageCode' | translate"
						[options]="languageOptions"
						[fullWidth]="true"
						[validationRules]="getValidationRules('languageCode')"
						[value]="company?.LanguageCode"
						(valueChange)="onValueChange('languageCode', $event)"
						(validationChange)="onValidationChange('languageCode', $event)">
					</eif-custom-select>
					<eif-custom-input
						#shareCapitalInput
						[label]="'company-details.shareCapital' | translate"
						[placeholder]="'company-details.shareCapital' | translate"
						[validationRules]="getValidationRules('shareCapital')"
						[value]="company?.ShareCapital | currencyFormatter"
						(valueChange)="onShareCapitalChange($event)"
						(validationChange)="onValidationChange('shareCapital', $event)"
						(keypress)="validateOnlyNumbers($event)">
					</eif-custom-input>
				</div>
			</div>
		</div>

		<div class="d-flex justify-content-end gap-1 mt-3">
			<eif-custom-button
				[text]="'button.back'"
				[color]="'neutral'"
				(action)="navigateToCompanyDetails()">
			</eif-custom-button>

			<eif-custom-button
				[type]="'submit'"
				[text]="'button.submit'"
				[disabled]="!isFormValid">
			</eif-custom-button>
		</div>
	</form>
</div>
